/**
 * Network Tracker
 *
 * Purpose:
 * - Tracks the number of active network requests in the app.
 * - Provides an API to listen for changes in active requests (e.g., for page load timing).
 *
 * How it works:
 * - `onRequestStart` should be called when a request begins.
 * - `onRequestEnd` should be called when a request finishes.
 * - `onNetworkChange` allows subscribing to changes in active request count.
 *
 * Notes:
 * - Console logs are commented out for optional future debugging.
 */

let activeRequests = 0;
const listeners = new Set();

// Notify all listeners about the current activeRequests count
const notify = () => {
  Array.from(listeners).forEach((cb) => cb(activeRequests));
};

// Call when a network request starts
export const onRequestStart = () => {
  // console.log('[NetworkTracker] Request started');
  activeRequests += 1;
  notify();
};

// Call when a network request ends
export const onRequestEnd = () => {
  // console.log('[NetworkTracker] Request ended');
  activeRequests = Math.max(0, activeRequests - 1); // Ensure it doesn't go negative
  notify();
};

// Subscribe to network activity changes
export const onNetworkChange = (callback) => {
  listeners.add(callback);
  return () => listeners.delete(callback); // Return an unsubscribe function
};

// Get the current number of active requests
export const getActiveRequests = () => activeRequests;
